var map = {
	"./armm.png": 448,
	"./car.png": 4479,
	"./i.png": 6856,
	"./ii.png": 2364,
	"./iii.png": 2139,
	"./iv-a.png": 3948,
	"./iv-b.png": 3040,
	"./ix.png": 2804,
	"./ncr.png": 372,
	"./v.png": 4692,
	"./vi.png": 7920,
	"./vii.png": 2800,
	"./viii.png": 1460,
	"./x.png": 3672,
	"./xi.png": 3864,
	"./xii.png": 4036,
	"./xiii.png": 6672
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2720;